var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uikit-form" }, [
    _c(
      "div",
      { staticClass: "uikit-modals" },
      [
        _c("m-table-settings", {
          attrs: {
            columns: _vm.modals.tableSettingsModal.columns,
            "disabled-columns": _vm.disabledColumns,
            "default-disabled-columns": _vm.defaultDisabledColumns,
            "with-categories": "",
          },
          model: {
            value: _vm.modals.tableSettingsModal.active,
            callback: function ($$v) {
              _vm.$set(_vm.modals.tableSettingsModal, "active", $$v)
            },
            expression: "modals.tableSettingsModal.active",
          },
        }),
        _c("m-items", {
          attrs: {
            "create-category": true,
            active: _vm.modals.createCategoryPositionsModal.active,
            groups: _vm.modals.createCategoryPositionsModal.groups,
            "current-group-item": _vm.modals.createCategoryPositionsModal.input,
            "required-message": "",
            "modal-title": "Создать категорию",
            "input-placeholder": "Введите название категории",
          },
          on: { close: _vm.closeCreateItemPositionsModal },
        }),
        _c("m-items", {
          attrs: {
            "modal-confirm": true,
            active: _vm.modals.removeCategoryPositionsModal.active,
            "modal-title": "Удаление категории",
            "modal-description": "Подтвердите удаление категории",
            "modal-description-item": "Категорию",
          },
          on: { close: _vm.closeRemoveItemPositionsModal },
        }),
        _c(
          "c-sidesheet",
          {
            attrs: {
              title: "Боковое модальное окно (sidesheet)",
              active: _vm.modals.sidesheet.active,
            },
            on: { close: _vm.closeSidesheet },
          },
          [_c("div", { staticClass: "mt-3" }, [_vm._v("Какой-то текст")])]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__subtitle" }, [_vm._v("Поля ввода")]),
    _c(
      "div",
      { staticClass: "uikit-form__inputs" },
      [
        _c(
          "b-row",
          { attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__inputs-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        placeholder: "Текстовое поле без лейбла",
                        type: "text",
                      },
                      model: {
                        value: _vm.inputs.simpleInput,
                        callback: function ($$v) {
                          _vm.$set(_vm.inputs, "simpleInput", $$v)
                        },
                        expression: "inputs.simpleInput",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__inputs-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        type: "textarea",
                        "textarea-max-height": "250",
                        placeholder: "Поле с автоматическим изменение высоты",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [
      _vm._v("Поля ввода с плавающей меткой"),
    ]),
    _c(
      "div",
      { staticClass: "uikit-form__inputs" },
      [
        _c(
          "b-row",
          { attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              {
                staticClass: "mt-2 mb-3",
                attrs: { sm: "12", md: "6", lg: "3" },
              },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__inputs-item" },
                  [
                    _c("c-input-old", {
                      attrs: {
                        clearable: true,
                        "floating-label": "Поле с плавающей меткой",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [
      _vm._v("Textarea (новый)"),
    ]),
    _c(
      "div",
      { staticClass: "uikit-form__inputs" },
      [
        _c(
          "b-row",
          { attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              {
                staticClass: "mt-2 mb-3",
                attrs: { sm: "12", md: "6", lg: "3" },
              },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__inputs-item" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        clearable: true,
                        label: "Поле с обычной меткой",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              {
                staticClass: "mt-2 mb-3",
                attrs: { sm: "12", md: "6", lg: "3" },
              },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__inputs-item" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        clearable: true,
                        label: "Поле с обычной меткой",
                        invalid: true,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              {
                staticClass: "mt-2 mb-3",
                attrs: { sm: "12", md: "6", lg: "3" },
              },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__inputs-item" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        clearable: true,
                        "floating-label": "Поле с плавающей меткой",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              {
                staticClass: "mt-2 mb-3",
                attrs: { sm: "12", md: "6", lg: "3" },
              },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__inputs-item" },
                  [
                    _c("c-textarea", {
                      attrs: {
                        clearable: true,
                        "floating-label": "Поле с плавающей меткой",
                        invalid: true,
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [
      _vm._v("Поле с возможностью копирования"),
    ]),
    _c(
      "div",
      [
        _c("copy-field", {
          attrs: {
            text: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia voluptate suscipit, ut consectetur officia numquam.",
          },
          on: { copied: _vm.onCopy },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [
      _vm._v("Выпадающие списки"),
    ]),
    _c(
      "div",
      { staticClass: "uikit-form__selects" },
      [
        _c(
          "b-row",
          { staticClass: "uikit-form__row", attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        label: "Простой выпадающий список",
                        type: "select",
                        items: _vm.selects.items,
                      },
                      model: {
                        value: _vm.selects.simpleSelectValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "simpleSelectValue", $$v)
                        },
                        expression: "selects.simpleSelectValue",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        label: "С возможностью сброса",
                        items: _vm.selects.items,
                        type: "select",
                        clearable: true,
                        placeholder: "Все",
                      },
                      model: {
                        value: _vm.selects.clearableSelectValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "clearableSelectValue", $$v)
                        },
                        expression: "selects.clearableSelectValue",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        label: "С поиском",
                        items: _vm.selects.items,
                        type: "select",
                        searchable: true,
                        clearable: true,
                        placeholder: "Все",
                      },
                      model: {
                        value: _vm.selects.searchableSelectValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "searchableSelectValue", $$v)
                        },
                        expression: "selects.searchableSelectValue",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "b-row",
          { staticClass: "uikit-form__row", attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        label: "С множественным выбором",
                        type: "select",
                        items: _vm.selects.items,
                        searchable: true,
                        multiple: true,
                        placeholder: "Все",
                      },
                      model: {
                        value: _vm.selects.multipleSelectValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "multipleSelectValue", $$v)
                        },
                        expression: "selects.multipleSelectValue",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        label: "С аватаром",
                        items: _vm.selectUsers,
                        type: "select",
                        searchable: true,
                        multiple: true,
                        placeholder: "Все",
                      },
                      model: {
                        value: _vm.selects.avatarSelectValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "avatarSelectValue", $$v)
                        },
                        expression: "selects.avatarSelectValue",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        type: "select",
                        label: "С опцией все кроме (чекбокс в виде иконки)",
                        checkbox: true,
                        "checkbox-type": "icon",
                        "checkbox-tooltip": {
                          disabledText:
                            "Фильтр по всем значениям в справочнике, кроме выбранных",
                          activeText:
                            "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                          notActiveText:
                            "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                        },
                        disabled:
                          _vm.selects.multipleWithIconValue.length === 0,
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.selects.items,
                      },
                      model: {
                        value: _vm.selects.multipleWithIconValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "multipleWithIconValue", $$v)
                        },
                        expression: "selects.multipleWithIconValue",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "b-row",
          { staticClass: "uikit-form__row" },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        type: "select",
                        label: "Простой селект с группировкой",
                        "with-categorized": true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.selects.itemsWithCategorized,
                      },
                      model: {
                        value: _vm.selects.withCategorized,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "withCategorized", $$v)
                        },
                        expression: "selects.withCategorized",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-select", {
                      attrs: {
                        type: "select",
                        label: "С опцией все кроме и групповыми значениями",
                        "reverse-type": "icon",
                        "reverse-tooltip": {
                          disabledText:
                            "Фильтр по всем значениям в справочнике, кроме выбранных",
                          activeText:
                            "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                          notActiveText:
                            "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                        },
                        multiple: true,
                        searchable: true,
                        placeholder: "Все",
                        items: _vm.selects.items,
                        groups: _vm.selects.groups,
                      },
                      model: {
                        value: _vm.selects.multipleWithGroup,
                        callback: function ($$v) {
                          _vm.$set(_vm.selects, "multipleWithGroup", $$v)
                        },
                        expression: "selects.multipleWithGroup",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "4" } },
              [
                _c(
                  "div",
                  { staticClass: "uikit-form__selects-item" },
                  [
                    _c("c-select", {
                      staticClass: "m-write-fine-form-item-row-basis",
                      attrs: {
                        type: "select",
                        label: "С одним выбором и групповыми значениями",
                        searchable: true,
                        items: _vm.selects.items,
                        groups: _vm.selects.groups,
                        placeholder: "Выберите значение",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [_vm._v("Выбор даты")]),
    _c(
      "div",
      { staticClass: "uikit-form__datepickers" },
      [
        _c(
          "b-row",
          { attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("c-input-2", {
                  attrs: {
                    label: "С не редактируемым полем",
                    type: "date",
                    format: "DD.MM.YYYY, dddd",
                    icon: "calendar",
                    placeholder: "Выберите дату",
                    "icon-right": true,
                    clearable: true,
                  },
                  model: {
                    value: _vm.datepickers.simpleValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.datepickers, "simpleValue", $$v)
                    },
                    expression: "datepickers.simpleValue",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("c-input-2", {
                  attrs: {
                    label: "Период",
                    placeholder: "Выберите период",
                    type: "period",
                    icon: "calendar",
                    "icon-right": true,
                  },
                  model: {
                    value: _vm.datepickers.editableValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.datepickers, "editableValue", $$v)
                    },
                    expression: "datepickers.editableValue",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("c-input-2", {
                  attrs: {
                    label: "Период без фикс. значений",
                    placeholder: "Выберите период",
                    type: "period-without-fixed-intervals",
                    icon: "calendar",
                    "icon-right": true,
                  },
                  model: {
                    value: _vm.datepickers.editableValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.datepickers, "editableValue", $$v)
                    },
                    expression: "datepickers.editableValue",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("c-input-2", {
                  attrs: {
                    label: "С редактируемым полем",
                    placeholder: "Все",
                    type: "date",
                    icon: "calendar",
                    "icon-right": true,
                    editable: true,
                  },
                  model: {
                    value: _vm.datepickers.periodValue,
                    callback: function ($$v) {
                      _vm.$set(_vm.datepickers, "periodValue", $$v)
                    },
                    expression: "datepickers.periodValue",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "b-row",
          { attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("week-days", {
                  model: {
                    value: _vm.weekDays,
                    callback: function ($$v) {
                      _vm.weekDays = $$v
                    },
                    expression: "weekDays",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("month-days", {
                  model: {
                    value: _vm.monthDays,
                    callback: function ($$v) {
                      _vm.monthDays = $$v
                    },
                    expression: "monthDays",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("date-select", {
                  model: {
                    value: _vm.yearDays,
                    callback: function ($$v) {
                      _vm.yearDays = $$v
                    },
                    expression: "yearDays",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("date-select", {
                  attrs: { "with-year": true },
                  model: {
                    value: _vm.randomDays,
                    callback: function ($$v) {
                      _vm.randomDays = $$v
                    },
                    expression: "randomDays",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "b-row",
          { attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("month-select", {
                  attrs: { label: "Период" },
                  model: {
                    value: _vm.month,
                    callback: function ($$v) {
                      _vm.month = $$v
                    },
                    expression: "month",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [_vm._v("Выбор цвета")]),
    _c(
      "div",
      { staticClass: "uikit-form__color" },
      [
        _c("color-select", {
          attrs: { label: "Выберите цвет", validate: true },
          model: {
            value: _vm.color,
            callback: function ($$v) {
              _vm.color = $$v
            },
            expression: "color",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [_vm._v("Переключатели")]),
    _c(
      "div",
      { staticClass: "uikit-form__switchers" },
      [
        _c(
          "div",
          { staticClass: "uikit-form__switchers-item" },
          [_c("c-switcher", { attrs: { label: "Переключатель" } })],
          1
        ),
        _c(
          "div",
          { staticClass: "uikit-form__switchers-item" },
          [_c("c-switcher", { attrs: { type: "checkbox", label: "Чекбокс" } })],
          1
        ),
        _c(
          "div",
          { staticClass: "uikit-form__switchers-item" },
          [
            _c("c-switcher", {
              attrs: {
                type: "checkbox",
                label: "Неактивный чекбокс",
                disabled: true,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "uikit-form__switchers-item" },
          [
            _c("c-switcher", {
              attrs: {
                type: "checkbox-icon",
                tooltip: {
                  disabledText:
                    "Фильтр по всем значениям в справочнике, кроме выбранных",
                  activeText:
                    "Включен фильтр по всем значениям в справочнике, кроме выбранных",
                  notActiveText:
                    "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                },
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "uikit-form__switchers-item" },
          [
            _c("c-switcher-2", {
              attrs: {
                type: "group",
                items: [
                  { icon: "ruble", value: "ruble" },
                  { icon: "percent", value: "percent" },
                ],
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "uikit-form__switchers-item" },
          [
            _c("c-switcher-2", {
              attrs: {
                type: "group",
                items: [
                  { label: "Число", value: "number" },
                  { label: "Диапазон", value: "range" },
                ],
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "uikit-form__switchers-item" },
          [
            _c("c-switcher-2", {
              staticClass: "h-switcher",
              attrs: {
                type: "group",
                items: [
                  { label: "Число", value: "number" },
                  { label: "Диапазон", value: "range" },
                ],
              },
            }),
          ],
          1
        ),
        _c(
          "b-row",
          { attrs: { cols: "12" } },
          [
            _c(
              "b-col",
              { staticClass: "mb-3", attrs: { sm: "12", md: "6", lg: "3" } },
              [
                _c("user-select", {
                  attrs: {
                    users: [
                      {
                        name: "Мария Иванова",
                        avatar: "",
                      },
                      {
                        name: "Александр Петров",
                        avatar: "",
                      },
                      {
                        name: "Василий Васильевич",
                        avatar: "",
                      },
                      {
                        name: "Вася Пупкин",
                        avatar: "",
                      },
                    ],
                    multiple: true,
                  },
                  model: {
                    value: _vm.selects.selectedUsers,
                    callback: function ($$v) {
                      _vm.$set(_vm.selects, "selectedUsers", $$v)
                    },
                    expression: "selects.selectedUsers",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [_vm._v("Модальные окна")]),
    _c("div", { staticClass: "uikit-form__modals" }, [
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button", {
            attrs: {
              responsive: "",
              label: "Настроить столбцы",
              icon: "cog",
              type: "with-icon",
            },
            on: {
              click: function ($event) {
                _vm.modals.tableSettingsModal.active = true
              },
            },
          }),
          _c("c-button", {
            staticClass: "ml-3",
            attrs: {
              responsive: "",
              label: "Создать категорию (должности)",
              icon: "plus",
              type: "with-icon",
            },
            on: {
              click: function ($event) {
                _vm.modals.createCategoryPositionsModal.active = true
              },
            },
          }),
          _c("c-button", {
            staticClass: "ml-3",
            attrs: {
              responsive: "",
              label: "Удалить категорию (должности)",
              icon: "trash",
              type: "with-icon",
            },
            on: {
              click: function ($event) {
                _vm.modals.removeCategoryPositionsModal.active = true
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "uikit-form__row" },
        [
          _c("c-button-2", {
            attrs: { label: "Боковое модальное окно", size: "small" },
            on: {
              click: function ($event) {
                _vm.modals.sidesheet.active = true
              },
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [
      _vm._v("Блоки с информацией"),
    ]),
    _vm._m(0),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "layout__subtitle" }, [
      _vm._v("Таблица с фиксированной шапкой"),
    ]),
    _c(
      "div",
      { staticClass: "uikit-form__table-wrapper" },
      [
        _c("c-data-table", {
          ref: "table",
          attrs: {
            levels: 2,
            "disabled-columns": _vm.disabledColumns,
            "enabled-fields": _vm.tableData.enabledFields,
            "sorted-column": _vm.tableData.sortedColumn,
            data: _vm.tableData,
            "filtered-columns": _vm.tableData.filteredColumns,
            "active-filtered-columns": _vm.tableData.activeFilteredColumns,
            "reference-list": _vm.tableData.referenceList,
          },
          on: {
            "reset-column-filters": function ($event) {
              _vm.tableData.activeFilteredColumns = []
            },
            "remove-column-filter": _vm.onColumnFilterRemove,
            "set-column-filter": _vm.onSetColumnFilter,
            "set-column-filter-by-index": _vm.onSetColumnFilterByIndex,
            "disable-column-sorted-flag": _vm.onDisableColumnSortedFlag,
            "change-sorting-column": _vm.onSortingColumnChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "uikit-form__info-block" }, [
      _c("div", { staticClass: "uikit-form__info-block-item" }, [
        _vm._v(" Выплачено производству: "),
        _c("span", [_vm._v("157 951 450 ฿")]),
      ]),
      _c("div", { staticClass: "uikit-form__info-block-item" }, [
        _vm._v(" Выплачено доставке: "),
        _c("span", [_vm._v("69 901 550 ฿")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }